import { logger } from '@/lib/logger';
import { ENVIRONMENT } from '@/lib/environment';

type AuthDebugEvent = {
  type: string;
  message?: string;
} & Record<string, unknown>;

export const appendAuthDebugLog = (event: AuthDebugEvent): void => {
  if (!ENVIRONMENT.isAuthDebug()) return;
  if (typeof window === 'undefined') return;

  const entry = { ...event, timestamp: Date.now() };
  logger.info(`[AUTH DEBUG] ${event.type}`, entry);

  try {
    const existing = JSON.parse(window.localStorage.getItem('authDebugLog') || '[]') as unknown[];
    existing.push(entry);
    window.localStorage.setItem('authDebugLog', JSON.stringify(existing.slice(-200)));
  } catch (err) {
    logger.debug('authDebug: unable to persist log', { err: err instanceof Error ? err.message : String(err) });
  }
};


